import { Box, styled, Theme } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const { DARK_CARDS_CONTAINER, LIGHT_CONTAINER } = COLORS;

export const MyLinksLayout = styled(Box)(({ theme, noPaddingInline }: { theme: Theme; noPaddingInline?: boolean }) => ({
  backgroundColor: theme.palette.type === 'dark' ? DARK_CARDS_CONTAINER : LIGHT_CONTAINER,
  borderRadius: '8px',
  padding: noPaddingInline ? `20px 0` : `20px 32px 18.1px 20px `,
}));
